// // components/userCabinet/LibraryCatalogBanner.jsx
// import { useEffect, useState } from "react";
// import { doc, getDoc } from "firebase/firestore";
// import { db } from "../../firebase";

// export default function LibraryCatalogBanner() {
//   const [banner, setBanner] = useState(null);

//   useEffect(() => {
//     const fetchBanner = async () => {
//       try {
//         const docRef = doc(db, "siteContent", "libraryCatalogBanner");
//         const snap = await getDoc(docRef);

//         if (!snap.exists()) {
//           return;
//         }

//         const data = snap.data();
//         if (data.active === false) return;

//         setBanner(data);
//       } catch (err) {
//         console.error("Помилка завантаження банера каталогу:", err);
//       }
//     };

//     fetchBanner();
//   }, []);

//   if (!banner) return null;

//   const handleClick = () => {
//     if (banner.linkUrl) {
//       window.open(banner.linkUrl, "_blank", "noopener,noreferrer");
//     }
//   };

//   return (
//     <div className="newBooksWrapBlock">
//       <div className="GreenBlockMal">
//         <div className="smallWrapForO">
//           <h1 className="HelpCreateBooks">Каталог для бібліотек</h1>
//           <p className="descriptionOpikunBook">{banner.bannerText}</p>
//         </div>

//         <div className="opRadaButton" onClick={handleClick}>
//           {banner.buttonText || "Відкрити каталог для бібліотек"}
//         </div>
//       </div>
//     </div>
//   );
// }
// components/userCabinet/LibraryCatalogBanner.jsx
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import css from "./LibraryCatalogBanner.module.css";

export default function LibraryCatalogBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchBanner = async () => {
      try {
        const docRef = doc(db, "siteContent", "libraryCatalogBanner");
        const snap = await getDoc(docRef);

        if (!snap.exists()) return;

        const data = snap.data();
        if (data.active === false) return;

        if (isMounted) {
          setBanner(data);
        }
      } catch (err) {
        console.error("Помилка завантаження банера каталогу:", err);
      }
    };

    fetchBanner();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!banner) return null;

  const handleClick = () => {
    if (banner.linkUrl) {
      window.open(banner.linkUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className={css.wrap}>
      <div className={css.inner}>
        <h2 className={css.title}>{banner.title || "Каталог для бібліотек"}</h2>
        {banner.bannerText && <p className={css.text}>{banner.bannerText}</p>}
        <div className={css.buttonRow}>
          <button type="button" className={css.button} onClick={handleClick}>
            {banner.buttonText || "Відкрити каталог для бібліотек"}
          </button>
        </div>
      </div>
    </div>
  );
}
